import { createContext } from 'react';
import CarrierSummary from '../../../../../services/insurance/types/carrier-name';
import { IvSummaryStatus } from '../../../../../services/insurance/types/iv-summary-status';
import { Provider } from '../../../../../services/insurance/types/provider';
import { VerificationPriority } from '../../../../../services/insurance/types/verification-priority';
import { VerificationSummary } from '../../../../../services/insurance/types/verification-summary';
import { IvPatientInfo } from '../../types/iv-patient-info';
import { PatientIvFlowProps } from '../../types/patient-iv-flow-props';

export interface PatientIvStatusDialogContextProps {
  opened: boolean;
  onClose: () => void;
  isLoading: boolean;
  isReady: boolean;
  locationId: number;
  patientFlow: PatientIvFlowProps;
  providerId: number | undefined;
  setIsLoading: (value: boolean) => void;
  patientInfo: IvPatientInfo;
  selectedIvSummary: VerificationSummary | undefined;
  verificationPriority: VerificationPriority;
  providers: Provider[];
  getProvider: (providerId?: number) => Provider | undefined | null;
  getCarrierSummary: (carrierNameId?: number) => CarrierSummary | undefined | null;
  sendIvStatusUpdatedEvent: (status?: IvSummaryStatus) => void;
  appointment?: {
    isEnded?: boolean;
  };
}

export const PatientIvStatusDialogContext = createContext<PatientIvStatusDialogContextProps>(null!);
